import React, { Component } from "react";
import CashBackBonusTerms from "../TermsConditionModal/CashBackBonusTerms"; 
import {Link} from 'react-router-dom'
import TermsConditionModal from "../TermsConditionModal/TermsConditionModal";


class LinkContentPaypal extends Component {
  constructor(props) {
    super(props)
        this.state = {
        showModal : false
    }
     
}
 
 handleOpenModel = (val) =>{
  this.setState({
    showModal: val
  })
 }

  render() {
    const Message = `By selecting \"Link Now,\" you authorize and direct Discover to provide PayPal with your name, email address, billing address and phone number, and the account number, card type, and the expiration date of your Discover card. In addition, you consent to (a) Discover sharing your rewards balance with PayPal, (b) the Discover Pay with `;
    
    return (
      <p className="termsAndCondition-footer">
        {Message}
          {/* <Link  id="cashback-bonus-terms" class="conditions" to={this.handleOpenModel} onClick={()=>this.handleOpenModel(true)}>Rewards Terms</Link>
          <TermsConditionModal close={close} title={title} footer = {footer} showModal = {this.state.showModal}>
              <CashBackBonusTermsPaypal/>
          </TermsConditionModal>   */}
          <a
          href="https://www.discover.com/credit-cards/paypal/terms-conditions.html"
          class="conditions"
          target="_blank"
          title="click here"  
        >
          Rewards Terms
        </a>
        , which registers your card in PayPal's Pay with Rewards program, 
          and (c) PayPal sending Discover the email address associated 
          with your PayPal account. By using the PayPal, you agree to the{" "} 
        <a
          href="https://www.paypal.com/us/webapps/mpp/ua/useragreement-full"
          class="conditions"
          target="_blank"
          title="click here"  
        >
          PayPal Terms
        </a>
        .
      <p class="leavingDiscoverWebsite-sub-head">Leaving Discover Website</p>
      By selecting "Link Now," you are leaving our website and entering 
      PayPal’s website or mobile application. Although we have a 
      relationship with this site/app, we do not provide the products and 
      services there. Please review the applicable privacy and security 
      policies and terms and conditions for PayPal’s site/app.
      
      </p>
    );
  
  }
}

export default LinkContentPaypal;

